import React, { FC } from 'react'
import { CSpinner } from '@coreui/react-pro'
import { WithdrawalEdit } from '../../edit'
import {
  buttonColorTransactionRequestStatus,
  statusWithdrawalFlow,
  transactionRequestStatus,
} from '../../../const'
import { submitSendWDWOTrading, submitStatus } from '../../edit/model'
import { MoneyHoneyModal } from '../MoneyHoneyModal/component'
import { Button, Modal } from 'antd'

type Props = {
  withdrawal: WithdrawalEdit
  textForCopy: string
  loading: boolean
  isLoadingRequestForDealers: boolean
  setIsOpenModal: (value: boolean) => void
}

export const WithdrawalButtons: FC<Props> = ({
  withdrawal,
  textForCopy,
  loading,
  setIsOpenModal,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        gap: 12,
      }}
    >
      {/* Left group */}
      <div style={{ display: 'flex', gap: 6 }}>
        <Button
          size="large"
          color="geekblue"
          variant="solid"
          onClick={() => {
            navigator.clipboard.writeText(
              textForCopy.replace(/^\s+|\s+(?=[\n\r])/gm, ''),
            )
          }}
        >
          Copy for Dealers
        </Button>

        {(statusWithdrawalFlow(
          withdrawal.status,
          withdrawal.mtTransactionId,
        ) as unknown as string[])?.includes(transactionRequestStatus.dealersCheck()) && (
          <Button
            size="large"
            style={{
              color: buttonColorTransactionRequestStatus(
                transactionRequestStatus.dealersCheck(),
              ).text,
              backgroundColor: buttonColorTransactionRequestStatus(
                transactionRequestStatus.dealersCheck(),
              ).background,
            }}
            onClick={() => {
              Modal.confirm({
                title: 'Change status',
                content: 'Are you sure you want to change the status?',
                okText: 'Yes',
                cancelText: 'No',
                onOk: () => {
                  submitStatus({
                    transactionId: withdrawal.transactionId,
                    status: transactionRequestStatus.dealersCheck(),
                  })
                },
              })
            }}
          >
            Dealers check
          </Button>
        )}

        <Button
          size="large"
          target="_blank"
          color="orange"
          variant="solid"
          href={
            'https://rdc.hwmt.link/module/query/info-by-client?id=' +
            withdrawal.client.clientId
          }
        >
          Open RDC
        </Button>
      </div>

      {/* Right group */}
      <div style={{ display: 'flex', gap: 6 }}>
        <Button
          size="large"
          color="geekblue"
          variant="solid"
          onClick={() => setIsOpenModal(true)}
        >
          Request technical help
        </Button>

        <MoneyHoneyModal loading={loading} withdrawal={withdrawal} />

        {(withdrawal.status == transactionRequestStatus.fundsReserved() ||
          withdrawal.status == transactionRequestStatus.pendingManager()) && (
          <Button
            size="large"
            color="danger"
            variant="solid"
            disabled={loading}
            onClick={() => {
              if (
                window.confirm(
                  'Клиент получит письмо о выводе без торговли. Вы уверены?',
                )
              ) {
                submitSendWDWOTrading({
                  id: Number(withdrawal.transactionId),
                  clientId: Number(withdrawal.clientId),
                })
              }
            }}
          >
            {loading ? <CSpinner size="sm" /> : 'WD WO TRADING'}
          </Button>
        )}
      </div>
    </div>
  )
}
